import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  causeName: "",
  country: "",
  state: "",
  postalCode: "",
  categories: [],
  contributionType: "Both",
  payoutPreference: "Either",
  tellUsMore: "",
  impactoverseBenefits: "",
  profilePicture: null, // Blob URL for preview
  coverPicture: null, // Blob URL for preview
  otherMedia: null, // Blob URL for preview
  profilePictureFile: null, // Actual File object
  coverPictureFile: null, // Actual File object
  otherMediaFile: null, // Actual File object
  primaryContact: {
    name: "",
    email: "",
    phone: "",
  },
  secondaryContact: {
    name: "",
    email: "",
    phone: "",
  },
  socialMediaLinks: {
    website: "",
    facebook: "",
    twitter: "",
    instagram: "",
    linkedin: "",
    youtube: "",
  },
  // Step completion tracking
  stepsCompleted: {
    step1: false,
    step2: false,
    step3: false,
    step4: false,
    step5: false,
  },
};

export const causeVerificationSlice = createSlice({
  name: "causeVerification",
  initialState,
  reducers: {
    updateCauseVerification: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetCauseVerification: () => initialState,
    markStepComplete: (state, action) => {
      const stepNumber = action.payload;
      state.stepsCompleted[`step${stepNumber}`] = true;
    },
    markStepIncomplete: (state, action) => {
      const stepNumber = action.payload;
      state.stepsCompleted[`step${stepNumber}`] = false;
    },
  },
});

// Validation functions for each step
export const validateStep1 = (state) => {
  return !!(
    state.causeName?.trim() &&
    state.country?.trim() &&
    state.state?.trim() &&
    state.categories?.length > 0
  );
};

export const validateStep2 = (state) => {
  return !!(
    state.tellUsMore?.trim()?.length >= 15 &&
    state.impactoverseBenefits?.trim()?.length >= 15
  );
};

export const validateStep3 = (state) => {
  return !!(
    (state.profilePicture || state.profilePictureFile) &&
    (state.coverPicture || state.coverPictureFile)
  );
};

export const validateStep4 = (state) => {
  const primary = state.primaryContact;
  const secondary = state.secondaryContact;
  
  const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  
  return !!(
    primary?.name?.trim() &&
    primary?.email?.trim() &&
    emailPattern.test(primary.email) &&
    primary?.phone?.trim() &&
    secondary?.name?.trim() &&
    secondary?.email?.trim() &&
    emailPattern.test(secondary.email) &&
    secondary?.phone?.trim()
  );
};

export const validateStep5 = (state) => {
  return !!(state.socialMediaLinks?.website?.trim());
};

// Helper to check if user can access a given step
export const canAccessStep = (state, targetStep) => {
  if (targetStep === 1) return true;
  for (let i = 1; i < targetStep; i++) {
    if (!state.stepsCompleted[`step${i}`]) {
      return false;
    }
  }
  return true;
};

// Helper to get first incomplete step
export const getFirstIncompleteStep = (state) => {
  for (let i = 1; i <= 5; i++) {
    if (!state.stepsCompleted[`step${i}`]) {
      return i;
    }
  }
  return 6; // All steps complete, can go to review
};

export const { updateCauseVerification, resetCauseVerification, markStepComplete, markStepIncomplete } =
  causeVerificationSlice.actions;
export default causeVerificationSlice.reducer;
